import React from 'react';
import { Info } from 'lucide-react';

/**
 * InfoTag Component
 * Displays an informational label with icon and optional tooltip
 * @param {string} label - Short label text
 * @param {string} description - Full description for title/tooltip
 * @param {string} variant - 'primary', 'success', 'warning', 'danger' (default: 'primary')
 */
export const InfoTag = ({ label, description, variant = 'primary' }) => {
  const variantStyles = {
    primary: {
      bg: 'rgba(123, 197, 255, 0.08)',
      border: 'rgba(123, 197, 255, 0.2)',
      text: '#7bc5ff',
      icon: '#7bc5ff',
    },
    success: {
      bg: 'rgba(126, 243, 190, 0.08)',
      border: 'rgba(126, 243, 190, 0.2)',
      text: '#7ef3be',
      icon: '#7ef3be',
    },
    warning: {
      bg: 'rgba(255, 157, 87, 0.08)',
      border: 'rgba(255, 157, 87, 0.2)',
      text: '#ff9d57',
      icon: '#ff9d57',
    },
    danger: {
      bg: 'rgba(255, 122, 162, 0.08)',
      border: 'rgba(255, 122, 162, 0.2)',
      text: '#ff7aa2',
      icon: '#ff7aa2',
    },
  };

  const style = variantStyles[variant] || variantStyles.primary;

  return (
    <div
      className="inline-flex items-center gap-2 px-2 py-1 rounded text-xs"
      style={{
        background: style.bg,
        border: `1px solid ${style.border}`,
        color: style.text,
      }}
      title={description}
    >
      <Info size={13} style={{ color: style.icon, flexShrink: 0 }} />
      <span className="font-mono">{label}</span>
    </div>
  );
};

export default InfoTag;
